/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DocumentsApiConfiguration, DocumentsApiConfigurationParams } from './documents-api-configuration';

import { DocumentsService } from './services/documents.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    DocumentsService,
    DocumentsApiConfiguration
  ],
})
export class DocumentsApiModule {
  static forRoot(params: DocumentsApiConfigurationParams): ModuleWithProviders<DocumentsApiModule> {
    return {
      ngModule: DocumentsApiModule,
      providers: [
        {
          provide: DocumentsApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: DocumentsApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('DocumentsApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
